export const DEFAULT_NUMBER_OF_SECTION_TO_DISPLAY = 5;
